import {inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {NavigationStart, Router} from '@angular/router';
import {filter} from 'rxjs/operators';

/** Route der Info-Seite für SSO-Gast-Accounts. */
export const GUEST_USER_INFO_ROUTE = '/guest-user-info';

/**
 * Merkt sich, dass das Backend Aufrufe dieses SSO-Accounts als Gast-Zugriff ablehnt.
 *
 * Der Merker gilt nur für die aktuell angezeigte Seite: ein Seitenaufruf löst viele parallele
 * Requests aus, die alle mit 403 enden — davon darf nur der erste auf die Info-Seite umleiten.
 * Sobald der Nutzer die nächste Aktion auslöst (Navigation auf eine andere Route), wird er
 * zurückgesetzt, damit die Info-Seite auch beim zweiten und jedem weiteren Versuch erscheint.
 */
@Injectable({providedIn: 'root'})
export class GuestAccountService {
  private readonly router = inject(Router);

  private blocked = false;

  constructor() {
    this.router.events.pipe(
      filter((event): event is NavigationStart => event instanceof NavigationStart),
      filter(event => !event.url.startsWith(GUEST_USER_INFO_ROUTE)),
      takeUntilDestroyed()
    ).subscribe(() => this.blocked = false);
  }

  isBlocked(): boolean {
    return this.blocked;
  }

  markBlocked(): void {
    this.blocked = true;
  }

  reset(): void {
    this.blocked = false;
  }
}
